import GuestIndexVue from "@/views/guest/GuestIndex.vue";

const guest = [
  {
    path: "/guest",
    name: "guest",
    component: GuestIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","receptionist","supervisor"],
      public: false,
    },
  },
];

export default guest;
